<div class="" fxLayout="column">
  <div
  *ngIf="(showRedirectAppStoreUrl | async) && !closeRedirect"
    class="redirect-store"
    fxLayout="column"
    fxLayoutAlign="center center"

  >
  <button fxFlexAlign="end" mat-icon-button (click)="closeRedirect = !closeRedirect">
    <mat-icon>close</mat-icon>
  </button>
    <h2>{{"REDIRECT_APP" | translate}}</h2>
  </div>


</div>
<router-outlet></router-outlet>

<!-- <app-test></app-test> -->
